import { render, staticRenderFns } from "./SearchTiersv2.vue?vue&type=template&id=47367ba6&"
import script from "./SearchTiersv2.vue?vue&type=script&lang=js&"
export * from "./SearchTiersv2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports